import { logEvent } from 'firebase/analytics';
import { analytics } from '@/utils/firebase';
import mixpanel from "./mixpanel";

export const fireEvent = (eventName: string, eventParams?: object) => {
    logEvent(analytics, eventName, eventParams);
    mixpanel.track(eventName, eventParams);

    if (eventName === "search_web_clicked" || eventName === "ad_click_web") {
        // Twitter
        if (typeof window.twq === 'function') window.twq('event', 'tw-p0eup-p1szc', {});

        // Tiktok
        if (typeof window.ttq?.track === 'function') window.ttq.track('Search', {});

        // Facebook
        if (typeof window.fbq === 'function') window.fbq('track', 'Search');

        // Bing
        window.uetq = window.uetq || [];
        window.uetq.push('event', 'search-car', {});

        // Clarity
        if (typeof window.clarity === 'function') window.clarity("set", "search", "true");

    }
    if (eventName === "ad_click_web") {
        // Facebook
        if (typeof window.fbq === 'function') window.fbq('track', 'InitiateCheckout');

        // Bing
        window.uetq = window.uetq || [];
        window.uetq.push('event', 'ad_click_web', {});
    }
};
